import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import { ButtonCloseModal } from "./styles";

export const ModalAlertCheckout = ({ modalAlert, setModalAlert, currencyURL = "" }) => {
  const { t } = useTranslation();
  const { isAuthenticated } = useSelector((state) => state.userReducer);

  const handleCloseModalAlert = () => setModalAlert((state) => ({ ...state, show: false }));

  return (
    <Dialog
      className="boxModal"
      open={modalAlert.show}
      onClose={handleCloseModalAlert}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span className="titleModal" style={{ marginBottom: -5 }}>
          {t(modalAlert.title)}
        </span>
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="pass-dialog-description" className="boxModal">
          <span className="formulario">
            <span className="description">{t(modalAlert.description)}</span>
          </span>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <div className="buttons">
          {modalAlert.titleButton === "BTN_LOGIN" ? (
            <Link to="/login">
              <ButtonCloseModal onClick={handleCloseModalAlert}>{t(modalAlert.titleButton)}</ButtonCloseModal>
            </Link>
          ) : modalAlert.titleButton === "BACK" ? (
            <>
              {isAuthenticated ? (
                <Link to="/manage-account/plan">
                  <ButtonCloseModal onClick={handleCloseModalAlert}>{t(modalAlert.titleButton)}</ButtonCloseModal>
                </Link>
              ) : (
                <a
                  target="_top"
                  rel="noreferrer"
                  href={`https://www.lingofor.me/lingo-us/lingo_plans.html${currencyURL !== "" ? "?currency=BRL" : ""}`}
                >
                  <ButtonCloseModal onClick={handleCloseModalAlert}>{t(modalAlert.titleButton)}</ButtonCloseModal>
                </a>
              )}
            </>
          ) : modalAlert.titleButton === "OK" ? (
            <Link to="/manage-account/plan">
              <ButtonCloseModal onClick={handleCloseModalAlert}>{t(modalAlert.titleButton)}</ButtonCloseModal>
            </Link>
          ) : (
            <ButtonCloseModal onClick={handleCloseModalAlert}>{t(modalAlert.titleButton)}</ButtonCloseModal>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAlertCheckout;
